import React from "react";
import { getProfileImageUrl } from "../utils/profileImage";

type Props = {
  profileUrl: string | null;
};

const UserPageAvatar: React.FC<Props> = ({ profileUrl }) => {
  const imageToShow = getProfileImageUrl(profileUrl);

  return (
    <div className="userpage-avatar-wrapper">
      <img src={imageToShow} alt="profile" className="userpage-avatar-img" />
    </div>
  );
};

export default UserPageAvatar;